import { useMutation } from '@tanstack/react-query';
import useAuth from '@/common/hooks/useAuth.ts';
import { validateOtpMutationFunction } from '@/modules/Auth/queries/validateOtp/validateOtpMutationFunction.ts';

const useValidateOtpRequest = () => {
  const { login } = useAuth();
  return useMutation({
    mutationFn: validateOtpMutationFunction,
    onSuccess: ({ access }) => {
      login(access);
    },
  });
};

export default useValidateOtpRequest;
